/**
 * Pin a `.tooltip` element below (or above, if it doesn't fit) a target's
 * bounding rect, clamped horizontally to the viewport. Sets inline top/left
 * and adds the `show` + `below` classes that reading.css's `.tooltip.below`
 * variant expects (transform reset + pointer-events: auto).
 *
 * Used by both the per-card color tooltip on the reading screen and the
 * spread description tooltip on the formations screen — same shape, same
 * margin, same clamp math, hence the shared helper.
 */
export function pinTooltipBelow(tooltip: HTMLElement, target: HTMLElement, margin = 12): void {
  tooltip.classList.add('show', 'below');
  const fr = target.getBoundingClientRect();
  const tw = tooltip.offsetWidth;
  const th = tooltip.offsetHeight;
  const fitsBelow = fr.bottom + margin + th + margin <= window.innerHeight;
  const top = fitsBelow ? fr.bottom + margin : Math.max(margin, fr.top - margin - th);
  const desiredLeft = fr.left + fr.width / 2 - tw / 2;
  const left = Math.max(margin, Math.min(desiredLeft, window.innerWidth - tw - margin));
  tooltip.style.top = `${top}px`;
  tooltip.style.left = `${left}px`;
}
